import { login } from '@edu-fe/login'
import api from './api'
import getOrderId from './get-order-id'

/**
 * 免费下单接口
 *
 * @param {Object} params 参数
 * @param {String} params.couponId 优惠券id
 * @param {String} params.courseId 商品id
 * @param {Number} params.type 商品类型
 * @param {String} params.from 订单来源
 * @param {Number} params.isSend 是否是赠送, 1:是 | 0:不是
 * @param {Number} params.theme 赠送主题
 * @param {String} params.wpsSid 用户id
 * @return {Promise} 接口返回信息 { giftId }
 */
export default async function pay (params) {
  const { code, data: giftId } = await api.PackageEduFePay.free(params)

  // 处理支付未登录
  if (code < 0) {
    return login().then(() => pay(params))
  }

  const orderId = await getOrderId(params.courseId)

  return { giftId, orderId }
}
